"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get isOfficeDocument () {
        return isOfficeDocument;
    },
    get supportsThumbnails () {
        return supportsThumbnails;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _constants = require("~/utils/nc-config/constants");
const isOfficeDocument = (..._args)=>{
    return false;
};
const supportsThumbnails = (attachment)=>{
    const mimetype = attachment.mimetype || attachment.mimeType;
    const size = attachment.size;
    // Skip thumbnail generation if size is missing, not a number, or exceeds limit
    if (!size || !(0, _nocodbsdk.ncIsNumber)(size) || size > (0, _constants.getThumbnailMaxSize)()) {
        return false;
    }
    return !!_attachmentHelpers.imageMimeTypes.includes(mimetype);
};
